/**
 * Shared AI model configuration.
 *
 * Lives in lib/ (not app/api/) so client components can safely import it
 * without risking accidental bundling of server-only imports that may be added
 * to agent code in the future.
 */

export interface IAIModelOption {
  /** Display name shown in the UI. */
  label: string;
  /** Compact label for small UI badges. */
  shortLabel: string;
  /** Bedrock model ID. */
  modelId: string;
}

export const AI_MODEL_OPTIONS: IAIModelOption[] = [
  {
    label: "Claude Sonnet 4.5",
    shortLabel: "Sonnet 4.5",
    modelId: "us.anthropic.claude-sonnet-4-5-20250929-v1:0",
  },
  {
    label: "Claude Sonnet 5",
    shortLabel: "Sonnet 5",
    modelId: "us.anthropic.claude-sonnet-5",
  },
  {
    label: "Mistral Large 3",
    shortLabel: "Mistral",
    modelId: "mistral.mistral-large-3-675b-instruct",
  },
];

export const DEFAULT_AI_MODEL_ID = "us.anthropic.claude-sonnet-4-5-20250929-v1:0";

/**
 * Validates a model ID against the server-side allowlist.
 * Returns the default model ID if the requested ID is not in the list.
 * Used by both server-side agents and client-side context.
 *
 * @param modelId - Model ID to validate.
 * @returns An allowlisted model ID.
 */
export function resolveAllowlistedModelId(modelId: string | undefined): string {
  if (!modelId) return DEFAULT_AI_MODEL_ID;

  return AI_MODEL_OPTIONS.some((m) => m.modelId === modelId)
    ? modelId
    : DEFAULT_AI_MODEL_ID;
}
